import { render, staticRenderFns } from "./inventory-item.vue?vue&type=template&id=29e025de&"
import script from "./inventory-item.vue?vue&type=script&lang=js&"
export * from "./inventory-item.vue?vue&type=script&lang=js&"
import style0 from "./inventory-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports